import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import ICONS from "../../../assets/Icons";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { useDispatch } from "react-redux";

const FieldForceTransactionMultiApprovalSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [successPageData, setsuccessPageData] = useState([]);
  const [successPageID, setsuccessPageID] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);

  const [approvedTransactions, setApprovedTransactions] = useState([]);
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementTxnData"),
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];

      const pending = transactions.filter(
        (transaction) => transaction.lifecycle_status === "pending",
      );
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved",
      );
      setsuccessPageData(storedSelectedApproval?.selectedSendTransactions);
      setPendingTransactions(pending);
      setApprovedTransactions(approved);
      setsuccessPageID(storedSelectedApproval.selectedTransactions);
    } else {
      setsuccessPageData([]);
      setsuccessPageID([]);
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const goToDashboard = () => {
    navigate("/field_force_transaction_dashboard");
  };

  const approveMoreTransactions = () => {
    navigate(
      "/field_force_transaction_dashboard/field_force_transaction_multi_approval",
    );
  };

  const buttonRows = [
    [
      {
        btnText: "Approve more transactions",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: approveMoreTransactions,
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  return (
    <>
      <StatusContainer
        status="success"
        title={successPageData.length && "Transactions approved successfully ."}
        buttonRows={buttonRows}
      >
        {approvedTransactions.length > GlobalConfiguration.lengthCheckZero && (
          <TabsWeapperSection
            title={`Distribution created  - ${successPageID.length}`}
          >
            <div className="flex flex-col">
              {successPageData.map((account, i) => (
                <InfoCard
                  key={i}
                  bgColor="var(--positive-card)"
                  hoverable="white"
                  // onClick={() =>
                  //   navigate(
                  //     `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                  //   )
                  // }
                  onClick={() => {}}
                  rows={[
                    {
                      leftTitle: accountNameStandardised(
                        account?.beneficiary_account_name,
                      ),
                      leftSubTitle: "Account name",
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      hasRight: true,
                      rightIcon: true,
                      rightText: true,
                      rightTitle: `INR ${FormatAmount({ price: account?.amount })}`,
                      rightSubTitle: "Amount",
                      // onClick: () =>
                      //   navigate(
                      //     `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                      //   ),
                      onClick: () => {},
                    },
                  ]}
                />
              ))}
            </div>
          </TabsWeapperSection>
        )}

        {pendingTransactions.length > GlobalConfiguration.lengthCheckZero && (
          <TabsWeapperSection
            title={`Pending  - ${pendingTransactions.length}`}
          >
            <div className="flex flex-col">
              {successPageData.map((account, i) => (
                <InfoCard
                  key={i}
                  bgColor="var(--positive-card)"
                  hoverable="white"
                  // onClick={() =>
                  //   navigate(
                  //     `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                  //   )
                  // }
                  onClick={() => {}}
                  rows={[
                    {
                      leftTitle: account?.beneficiary_account_name
                        ?.toLowerCase()
                        .split(" ")
                        .map(
                          (w) =>
                            w
                              .charAt(GlobalConfiguration.lengthCheckZero)
                              .toUpperCase() +
                            w.slice(GlobalConfiguration.lengthCheckOne),
                        )
                        .join(" "),
                      leftSubTitle: "Account name",
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      hasRight: true,
                      rightIcon: true,
                      rightText: true,
                      rightTitle: `INR ${FormatAmount({ price: account?.amount })}`,
                      rightSubTitle: "Amount",
                      // onClick: () =>
                      //   navigate(
                      //     `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                      //   ),
                      onClick: () => {},
                    },
                  ]}
                />
              ))}
            </div>
          </TabsWeapperSection>
        )}

        {pendingTransactions.length > GlobalConfiguration.lengthCheckZero &&
          approvedTransactions.length > GlobalConfiguration.lengthCheckZero && (
            <>
              <TabsWeapperSection
                title={`Distribution created   - ${approvedTransactions?.length}`}
              >
                <div className="flex flex-col">
                  {successPageData.map((account, i) => (
                    <InfoCard
                      key={i}
                      bgColor="var(--positive-card)"
                      hoverable="white"
                      // onClick={() =>
                      //   navigate(
                      //     `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                      //   )
                      // }
                      onClick={() => {}}
                      rows={[
                        {
                          leftTitle: account?.beneficiary_account_name
                            ?.toLowerCase()
                            .split(" ")
                            .map(
                              (w) =>
                                w
                                  .charAt(GlobalConfiguration.lengthCheckZero)
                                  .toUpperCase() +
                                w.slice(GlobalConfiguration.lengthCheckOne),
                            )
                            .join(" "),
                          leftSubTitle: "Account name",
                          rightTitleTextColor: "var(--text-primary)",
                          rightTextFontWeight: "semibold",
                          hasRight: true,
                          rightIcon: true,
                          rightText: true,
                          rightTitle: `INR ${FormatAmount({ price: account?.amount })}`,
                          rightSubTitle: "Amount",
                          // onClick: () =>
                          //   navigate(
                          //     `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                          //   ),
                          onClick: () => {},
                        },
                      ]}
                    />
                  ))}
                </div>
              </TabsWeapperSection>
              <TabsWeapperSection
                title={`Pending  - ${pendingTransactions?.length}`}
              >
                <div className="flex flex-col">
                  {successPageData.map((account, i) => (
                    <InfoCard
                      key={i}
                      bgColor="var(--positive-card)"
                      hoverable="white"
                      // onClick={() =>
                      //   navigate(
                      //     `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                      //   )
                      // }
                      onClick={() => {}}
                      rows={[
                        {
                          leftTitle: account?.beneficiary_account_name
                            ?.toLowerCase()
                            .split(" ")
                            .map(
                              (w) =>
                                w
                                  .charAt(GlobalConfiguration.lengthCheckZero)
                                  .toUpperCase() +
                                w.slice(GlobalConfiguration.lengthCheckOne),
                            )
                            .join(" "),
                          leftSubTitle: "Account name",
                          rightTitleTextColor: "var(--text-primary)",
                          rightTextFontWeight: "semibold",
                          hasRight: true,
                          rightIcon: true,
                          rightText: true,
                          rightTitle: `INR ${FormatAmount({ price: account?.amount })}`,
                          rightSubTitle: "Amount",
                          // onClick: () =>
                          //   navigate(
                          //     `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                          //   ),
                          onClick: () => {},
                        },
                      ]}
                    />
                  ))}
                </div>
              </TabsWeapperSection>
            </>
          )}
      </StatusContainer>
    </>
  );
};

export default FieldForceTransactionMultiApprovalSuccess;
